import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { showApiErrors } from '@/utils';
import { createCoupon, getCoupons, updateCoupon } from './actionCreators';
import { SLICE_NAME, CouponsState, initialState } from './models';

export const couponsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCoupons.fulfilled, (state: CouponsState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.coupons = payload.promotions;
      })
      .addCase(createCoupon.fulfilled, (state: CouponsState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.coupons = [payload, ...(state.coupons ?? [])];
      })
      .addCase(updateCoupon.fulfilled, (state: CouponsState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.coupons = (state.coupons ?? []).map((channel) => (channel.id === payload.id ? payload : channel));
      })
      .addMatcher(isPending(getCoupons, createCoupon, updateCoupon), (state: CouponsState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isRejected(getCoupons, createCoupon, updateCoupon), (state: CouponsState, action) => {
        const { error } = action;
        state.isLoading = false;
        state.error = error;
        showApiErrors(error);
      });
  },
});
